exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2cc7504e] .v-selection-control {\n  min-height: 0;\n  height: auto;\n}\n[data-v-2cc7504e] .v-label {\n  margin-bottom: 0;\n  line-height: 1;\n}\n", ""]);

// exports
